/* esm.sh - applesauce-core@5.2.0/dist/helpers/relays */
export * from "/*applesauce-core@5.2.0/esnext/dist/helpers/relays.mjs";
